var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.isCustomer)?_c('HomeCustomer'):_vm._e(),(_vm.isOffice)?_c('HomeOffice'):_vm._e(),(_vm.isDriver)?_c('HomeDriver'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }